import { Button, Dialog, IconButton, Text, Tooltip } from '@radix-ui/themes';
import { UserPlus } from 'lucide-react';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Select from '../../../elements/Select';
import RoleCards from './RoleCards';
import { viewerRoleId } from './roles';
import type { AddGroupMemberProps } from './types/addGroupMemberProps';

const AddGroupMember = ({
  onSubmit,
  accessGroup,
  users,
  loading,
  roles,
  canAssignSuperAdmin,
  disable,
}: AddGroupMemberProps) => {
  const { t } = useTranslation();
  const [userInvite, setUserInvite] = useState<string>('');
  const [roleId, setRoleId] = useState<string>(() => viewerRoleId(roles ?? []));
  const [options, setOptions] = useState<{ label: string; value: string }[]>([]);
  const [groupMemberIds, setGroupMemberIds] = useState<string[]>([]);

  const handleSubmit = () => {
    onSubmit(accessGroup.id, userInvite!, [roleId]).then(() => {});
  };

  useEffect(() => {
    const memberIds: string[] = [];

    accessGroup?.members.map((user) => {
      memberIds.push(user.id);
    });

    setGroupMemberIds(memberIds);
  }, [accessGroup]);

  useEffect(() => {
    const memberOptions: { label: string; value: string }[] = [];

    users?.map((user) => {
      if (!groupMemberIds.includes(user.id)) {
        memberOptions.push({ label: `${user.firstName} ${user.lastName}`, value: user.id });
      }
    });

    setOptions(memberOptions);
  }, [users, accessGroup, groupMemberIds]);

  return (
    <Dialog.Root
      onOpenChange={() => {
        setUserInvite('');
        setRoleId(viewerRoleId(roles ?? []));
      }}
    >
      <Tooltip
        content={
          <Text size="3">
            {disable
              ? t('settings.accessGroupv2.addGroupMembers.noPermissionTooltip')
              : t('settings.accessGroupv2.addGroupMembers.addUserTooltip')}
          </Text>
        }
      >
        <Dialog.Trigger>
          <IconButton variant="ghost" color="gray" highContrast className="m-0" disabled={disable}>
            <UserPlus size={20} />
          </IconButton>
        </Dialog.Trigger>
      </Tooltip>
      <Dialog.Content aria-describedby={undefined}>
        <Dialog.Title>{t('settings.accessGroupv2.addGroupMembers.dialogTitle')}</Dialog.Title>
        <div className="flex flex-col gap-2">
          <Select
            options={options}
            onChange={setUserInvite}
            placeholder={t('settings.accessGroupv2.addGroupMembers.userPlaceholder')}
            className="w-full! my-2"
          />
          <RoleCards
            roles={roles ?? []}
            value={roleId}
            onValueChange={setRoleId}
            canAssignSuperAdmin={canAssignSuperAdmin}
          />
          <div className="flex flex-row justify-between w-full pt-4">
            <Dialog.Close>
              <Button size="3" color="gray" variant="soft" className="w-full">
                {t('settings.accessGroupv2.addGroupMembers.cancelButton')}
              </Button>
            </Dialog.Close>
            <Dialog.Close>
              <Button
                size="3"
                className="w-full"
                disabled={!userInvite || !roleId || loading}
                loading={loading}
                onClick={handleSubmit}
              >
                {t('settings.accessGroupv2.addGroupMembers.addButton')}
              </Button>
            </Dialog.Close>
          </div>
        </div>
      </Dialog.Content>
    </Dialog.Root>
  );
};

export default AddGroupMember;
